import { AuthLetterReviewStatus } from "../../../../../shared/enums/authLetterReviewStatus";
import DocWithUploadIcon from "../../../../../shared/svg/doc-with-upload-icon";
import DocumentUploadSuccess from "../../../../../shared/svg/documentUploadSuccess";

/** New letter uploaded: pale peach bg, terracotta stroke */
const NEW_LETTER_BG = "#FFF3E0";
const NEW_LETTER_STROKE = "#C24400";
/** Reviewed and saved: light green bg, dark green stroke */
const REVIEWED_BG = "#E6F3F0";
const REVIEWED_STROKE = "#005D49";

interface IsDocumentUploadedProps {
  isUploaded: boolean;
  isVisible: boolean;
  orderId: string;
  jCode: string;
  jCodeId: string;
  authStatus: string;
  authLetterReviewStatus?: string;
  onUploadClick: (
    orderId: string,
    jCode: string,
    jCodeId: string,
    authStatus: string,
    authLetterReviewStatus?: string,
  ) => void;
  onSuccessClick: (
    orderId: string,
    jCode: string,
    jCodeId: string,
    authStatus: string,
    authLetterReviewStatus?: string,
  ) => void;
}

const IsDocumentUploaded = (props: IsDocumentUploadedProps) => {
  if (!props.isVisible) {
    return null;
  }
  const isNewLetterUploaded =
    props.authLetterReviewStatus === AuthLetterReviewStatus.NewLetterUploaded;
  const isReviewedAndSaved =
    props.authLetterReviewStatus === AuthLetterReviewStatus.ReviewedAndSaved;

  const handleUploadClick = () => {
    props.onUploadClick(
      props.orderId,
      props.jCode,
      props.jCodeId,
      props.authStatus,
      props.authLetterReviewStatus,
    );
  };
  const handleSuccessClick = () => {
    props.onSuccessClick(
      props.orderId,
      props.jCode,
      props.jCodeId,
      props.authStatus,
      props.authLetterReviewStatus,
    );
  };

  const getIcon = () => {
    if (isNewLetterUploaded) {
      return (
        <DocumentUploadSuccess
          height={"20px"}
          width={"20px"}
          backgroundColor={NEW_LETTER_BG}
          strokeColor={NEW_LETTER_STROKE}
        />
      );
    }
    if (isReviewedAndSaved) {
      return (
        <DocumentUploadSuccess
          height={"20px"}
          width={"20px"}
          backgroundColor={REVIEWED_BG}
          strokeColor={REVIEWED_STROKE}
        />
      );
    }
    if (props.isUploaded) {
      return (
        <DocumentUploadSuccess
          height={"20px"}
          width={"20px"}
          backgroundColor="#00775E"
          strokeColor="white"
        />
      );
    }
    return <DocWithUploadIcon height={"20px"} width={"20px"} color="#0056D6" />;
  };

  return (
    <div className="table-cell-document-uploaded flex h-full w-full items-center justify-center">
      <div
        className="document-upload-icon--container flex items-center justify-center rounded-[0.25rem]"
        style={{
          cursor: "pointer",
          ...(isReviewedAndSaved && { backgroundColor: REVIEWED_BG }),
        }}
        onClick={props.isUploaded ? handleSuccessClick : handleUploadClick}
        role="button"
      >
        {getIcon()}
      </div>
    </div>
  );
};

export default IsDocumentUploaded;
